import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'bb-payments-sr-search-result-info',
  templateUrl: 'sr-search-result-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsSrSearchResultInfoComponent {
  private readonly debounceTotal = new BehaviorSubject<number | undefined | null>(undefined);
  readonly total$ = this.debounceTotal.pipe(debounceTime(1000));

  /**
   * Total count of search result.
   */
  @Input()
  set totalNumber(val: number | undefined | null) {
    this.debounceTotal.next(val);
  }

  isNumber(val: number | undefined | null): boolean {
    return typeof val === 'number';
  }
}
